import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceAISuggestionsPage from "@/pages/admin/PerformanceAISuggestionsPage";

export const Route = createFileRoute("/_admin/admin/performance/ai-suggestions")({
  head: () => pageHead("Admin · Performance · Ai Suggestions", "AKIVA admin · performance · ai suggestions portal.", "/admin/performance/ai-suggestions", true),
  component: PerformanceAISuggestionsPage,
});
